import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-owns"]
const _hoisted_2 = ["draggable", "onClick", "onDragstart", "onDragend"]
const _hoisted_3 = ["id", "aria-selected", "aria-label", "aria-controls", "onKeyup"]
const _hoisted_4 = ["alt"]
const _hoisted_5 = { class: "tab-label" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["alt"]

import { PropType } from 'vue';
import { RcButton } from '@components/RcButton';
import { RcIcon } from '@components/RcIcon';
import { BOTTOM } from '@shell/utils/position';
import { Position, Tab } from '@shell/types/window-manager';
import TabBodyContainer from './TabBodyContainer.vue';
import { tabBodyId, tabId } from './tab-body';
import usePanelHandler from '../composables/usePanelHandler';


export default /*@__PURE__*/_defineComponent({
  __name: 'HorizontalPanel',
  props: {
  position: {
    type:    String as PropType<Position>,
    default: BOTTOM,
  },
},
  setup(__props) {

const props = __props;

const {
  tabs,
  activeTab,
  isTabsHeaderEnabled,
  dragOverPositionsActive,
  dragOverTabBarActive,
  setTabActive,
  onTabReady,
  onTabClose,
  mouseResizeYStart,
  keyboardResizeY,
  onTabBarDragOver,
  onTabBarDragLeave,
  onTabBarDrop,
  onDragPositionStart,
  onDragPositionEnd,
  lockedPosition,
} = usePanelHandler({ position: props.position });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "horizontal-window-manager",
    "data-testid": "horizontal-window-manager",
    class: _normalizeClass(["horizontal-window-manager wm", {
      'drag-start': _unref(dragOverPositionsActive),
      'drag-end': !_unref(dragOverPositionsActive),
      'tabs-header-enabled': _unref(isTabsHeaderEnabled),
    }])
  }, [
    (_unref(isTabsHeaderEnabled))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['tabs', { 'tab-bar-highlight': _unref(dragOverTabBarActive) }]),
          onDragover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(onTabBarDragOver) && _unref(onTabBarDragOver)(...args))),
          onDragleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(onTabBarDragLeave) && _unref(onTabBarDragLeave)(...args))),
          onDrop: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(onTabBarDrop) && _unref(onTabBarDrop)(...args)))
        }, [
          _createElementVNode("div", {
            role: "tablist",
            "aria-owns": _unref(tabs).map((tab) => _unref(tabId)(props.position, tab.id)).join(' ')
          }, null, 8, _hoisted_1),
          _cache[9] || (_cache[9] = _createTextVNode()),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["tab", {
          'active': tab.id === _unref(activeTab)[props.position],
          'draggable': !_unref(lockedPosition),
        }]),
              draggable: tab.id === _unref(activeTab)[props.position] && !_unref(lockedPosition),
              onClick: ($event: any) => (_unref(setTabActive)({ position: props.position, id: tab.id })),
              onDragstart: ($event: any) => (_unref(onDragPositionStart)({ event: $event, tab })),
              onDragend: ($event: any) => (_unref(onDragPositionEnd)({ event: $event, tab }))
            }, [
              _createElementVNode("div", {
                id: _unref(tabId)(props.position, tab.id),
                class: "tab-title",
                role: "tab",
                "aria-selected": tab.id === _unref(activeTab)[props.position],
                "aria-label": tab.label,
                "aria-controls": _unref(tabBodyId)(props.position, tab.id),
                tabindex: "0",
                onKeyup: _withKeys(($event: any) => (_unref(setTabActive)({ position: props.position, id: tab.id })), ["enter","space"])
              }, [
                (tab.icon)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(["icon", {
              ['icon-'+ tab.icon]: true,
            }]),
                      alt: _ctx.t('wm.tabIcon')
                    }, null, 10, _hoisted_4))
                  : _createCommentVNode("", true),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createElementVNode("span", _hoisted_5, _toDisplayString(tab.label), 1)
              ], 40, _hoisted_3),
              _cache[8] || (_cache[8] = _createTextVNode()),
              _createVNode(_unref(RcButton), {
                "data-testid": "wm-tab-close-button",
                variant: "ghost",
                size: "small",
                class: "closer wm-closer-button",
                tabindex: "0",
                "aria-label": _ctx.t('wm.closeTab', { tabId: tab.id }),
                onClick: _withModifiers(($event: any) => (_unref(onTabClose)(tab.id)), ["stop"]),
                onKeyup: _withKeys(_withModifiers(($event: any) => (_unref(onTabClose)(tab.id)), ["stop"]), ["enter","space"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(RcIcon), {
                    type: "close",
                    size: "inherit"
                  })
                ]),
                _: 1
              }, 8, ["aria-label", "onClick", "onKeyup"])
            ], 42, _hoisted_2))
          }), 128)),
          _cache[10] || (_cache[10] = _createTextVNode()),
          _createElementVNode("div", {
            class: "resizer resizer-y",
            role: "button",
            tabindex: "0",
            "aria-label": _ctx.t('wm.resize', {arrow1: 'up', arrow2: 'down'}),
            "aria-expanded": "true",
            onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(mouseResizeYStart)($event)), ["prevent","stop"])),
            onTouchstart: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(mouseResizeYStart)($event)), ["prevent","stop"])),
            onKeyup: [
              _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_unref(keyboardResizeY)(true)), ["prevent","stop"]), ["up"])),
              _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_unref(keyboardResizeY)(false)), ["prevent","stop"]), ["down"]))
            ]
          }, [
            _createElementVNode("i", {
              class: "icon icon-sort",
              alt: _ctx.t('wm.resize', {arrow1: 'up', arrow2: 'down'})
            }, null, 8, _hoisted_7)
          ], 40, _hoisted_6)
        ], 34))
      : _createCommentVNode("", true),
    _cache[11] || (_cache[11] = _createTextVNode()),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
      return _withDirectives((_openBlock(), _createBlock(TabBodyContainer, {
        id: tab.id,
        key: `${ props.position }-${ tab.id }`,
        position: props.position,
        onReady: ($event: any) => (_unref(onTabReady)({ tab, containerId: $event }))
      }, null, 8, ["id", "position", "onReady"])), [
        [_vShow, tab.id === _unref(activeTab)[props.position]]
      ])
    }), 128))
  ], 2))
}
}

})